import { render, staticRenderFns } from "./OwnerSettlements.vue?vue&type=template&id=3470c345&scoped=true&lang=pug"
import script from "./OwnerSettlements.vue?vue&type=script&lang=js"
export * from "./OwnerSettlements.vue?vue&type=script&lang=js"
import style0 from "./OwnerSettlements.vue?vue&type=style&index=0&id=3470c345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3470c345",
  null
  
)

export default component.exports